import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-start pl-5 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-[28px] text-v_dark_blue" }, "Como podemos te ajudar?", -1)
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = { class: "w-full px-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-[28px] text-v_dark_blue" }, "Tópicos de ajuda:", -1)

import { Paragraph, HeaderContainer, H1, Button } from "../atoms"
import { answers } from "../../utils/FAQAnswer"
import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqExternal',
  setup(__props) {

let panel = ref()

const questions = ref([
	{
		title: "1. Não consegue fazer login na plataforma?",
		response: answers.login,
	},

	{
		title: "2. Como posso trocar minha senha?",
		response: answers.changePassword,
	},
	{
		title: "3. Usuário incorreto ",
		response: answers.wrongUser,
	},
])

return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_unref(HeaderContainer), null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(H1), { class: "text-v_dark_blue lg:text-[2rem] mt-10 ml-5" }, {
          default: _withCtx(() => [
            _createTextVNode(" Bem vindo ao FAQ do Portal Comissão ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(Paragraph), { class: "text-v_gray3 mt-2" }, {
          default: _withCtx(() => [
            _createTextVNode(" Escolha um topico que corresponda a sua dúvida ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_v_expansion_panels, {
            modelValue: _unref(panel),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(panel) ? (panel).value = $event : panel = $event)),
            disabled: false,
            multiple: "",
            class: "mt-3 mb-8 z-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (items, index) => {
                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(items.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.response, (response, index) => {
                      return (_openBlock(), _createBlock(_component_v_expansion_panel_text, { key: index }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(response), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_unref(Button), {
        class: "!rounded-md ml-5 mb-5 active:scale-90",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Voltar ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})